import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import React, { useContext } from 'react';
import { GlobalStateContext } from '@src/context/GlobalContextProvider';

const PlacementBanner = () => {
  const state = useContext(GlobalStateContext);

  const handleDownload = () => {
    const downloadUrl =
      'https://drive.google.com/uc?export=download&id=1CnMFXO3pVM__n3jjeKLDjo767tNRprvB';
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', 'Placement_Report.pdf'); // Optional name
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div className="my-10 mx-4 flex flex-col items-center space-y-4 rounded-2xl bg-[#6ef0c2] p-6 text-center shadow-md md:mx-auto md:max-w-[1000px]">
      <img
        src="/images/PlacementImage.webp"
        alt="Placement Chart"
        className="w-[100px] object-contain md:w-[180px]"
      />

      <h2 className="font-manrope text-[20px] text-black md:text-[36px] md:font-extrabold md:leading-[66px]">
        2500+ Learners Placed In Top Companies
      </h2>

      <LeadGenerationButton
        type={''}
        text="Download Placement Report"
        isOnePageForm
        formHeading="Placement Report"
        pageOneButtonText="Download Now"
        className={''}
        buttonLocation={'LEAD_GEN_DOWNLOAD_CURRICULUM'}
        onSubmitPageOne={() => {
          handleDownload();
        }}
        {...(state.email &&
          state.phone && {
            onClick: () => {
              handleDownload();
            },
          })}
      ></LeadGenerationButton>
    </div>
  );
};

export default PlacementBanner;
